var sortedCollections = [
  'all-lego-lights',
  'best-selling-lego-lights',
  'new-arrivals',
  'nameplate',
  'star-wars-lights',
  'creator-lights',
  'architecture-lights',
  'technic-lights',
  'harry-potter-lights',
  'speed-champion',
];
function sortFilterCollection() {
  var filterCollectionSlide = document.querySelectorAll('.filter-collection .swiper-slide');
  if (!filterCollectionSlide[0]) {
    return;
  }

  filterCollectionSlide.forEach(function (item) {
    var collectionName = item.getAttribute('data-collection-name');
    var index = sortedCollections.indexOf(collectionName);
    if (index > -1) {
      item.style.order = index;
    } else {
      item.style.order = 20;
    }
  });
}
function initializeFilterSlider() {
  var filterSliderElms = document.querySelectorAll('.filter-collection__item');
  var filterSliderWrapper = document.querySelector('.filter-collection .swiper-container');
  if (!filterSliderWrapper && filterSliderElms.length < 1) {
    return;
  }

  var filterSlider = new Swiper(filterSliderWrapper, {
    slidesPerView: 'auto',
    spaceBetween: 10,
    freeMode: true,
    watchOverflow: true,
    // this bar is desktop-only (small-hide), so drag/swipe isn't needed —
    // mouse wheel / trackpad scroll is the expected desktop interaction.
    // NOTE: forceToAxis is intentionally omitted — for a horizontal swiper
    // Swiper only accepts wheel input on the dominant axis, and a normal
    // mouse wheel reports vertical delta, so forceToAxis:true would reject
    // exactly the plain vertical scroll most users actually use.
    allowTouchMove: false,
    mousewheel: {
      releaseOnEdges: true,
    },
    // provisional; corrected empirically below once real slide widths are
    // measurable (see FADE_MASK_WIDTH comment)
    slidesOffsetAfter: 40,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
  });

  // Center the given slide index in the viewport, clamped to the swiper's
  // real scroll bounds. Always keeps the target fully visible — at the
  // edges of the list it naturally settles flush against that edge instead
  // of trying to center (there's nothing to show on the other side).
  function centerSlide(swiper, index) {
    var slide = swiper.slides[index];
    if (!slide) return;
    var target = slide.offsetLeft + slide.offsetWidth / 2 - swiper.width / 2;
    var translate = -target;
    var min = swiper.minTranslate();
    var max = swiper.maxTranslate();
    if (translate > min) translate = min;
    if (translate < max) translate = max;
    swiper.setTranslate(translate);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }

  // Swiper's internal per-slide width measurement consistently drifts from
  // the slides' real rendered widths here (root cause not isolated — it
  // reproduces fresh on every reload, in a brand new tab, and survives
  // destroy()+reinit, so it isn't stale caching). That inflates virtualSize
  // and leaves a large empty gap after the last slide even once fully
  // scrolled. Rather than depend on Swiper's own size math, measure the
  // real total width and correct slidesOffsetAfter so the trailing gap
  // matches the fade-mask width regardless of that drift.
  function correctTrailingOffset(swiper) {
    var FADE_MASK_WIDTH = 40; // matches section-filter-collection.css ::after
    var slideEls = filterSliderWrapper.querySelectorAll('.swiper-slide');
    var realTotal = 0;
    slideEls.forEach(function (el, idx) {
      realTotal += el.getBoundingClientRect().width;
      if (idx < slideEls.length - 1) realTotal += swiper.params.spaceBetween;
    });
    var drift = swiper.virtualSize - realTotal - swiper.params.slidesOffsetAfter;
    var corrected = FADE_MASK_WIDTH - drift;
    // Defensive: if the container was laid out with zero size when this ran
    // (e.g. an inactive/backgrounded tab mid page-load), realTotal/virtualSize
    // read as 0 or NaN — bail out and leave the original offset rather than
    // writing a bad value that corrupts the swiper instance's size cache for
    // the rest of the page's life.
    if (!isFinite(corrected) || !swiper.virtualSize) return;
    swiper.params.slidesOffsetAfter = corrected;
    swiper.update();
  }

  for (var i = 0; i < filterSliderElms.length; i++) {
    if (filterSliderElms[i].parentElement.classList.contains('active')) {
      // Deferred: measuring/positioning synchronously right after
      // `new Swiper()` can run before Swiper finishes indexing its slides.
      // setTimeout (not requestAnimationFrame) so this still runs even if
      // the tab is backgrounded/hidden during page load. If the layout
      // genuinely isn't ready yet (e.g. a backgrounded tab reports 0-width
      // elements), retry a few times rather than silently leaving the bar
      // unpositioned for the rest of the page's life.
      (function (activeIndex) {
        var attempts = 0;
        function attempt() {
          attempts += 1;
          filterSlider.update();
          if (!filterSlider.width && attempts < 10) {
            setTimeout(attempt, 100);
            return;
          }
          correctTrailingOffset(filterSlider);
          centerSlide(filterSlider, activeIndex);
        }
        setTimeout(attempt, 0);
      })(i);
      break;
    }
  }
}

document.addEventListener('DOMContentLoaded', function () {
  // sortFilterCollection();
  initializeFilterSlider();
});
